import { createAuthClient } from "better-auth/react";
import { createContext, useContext } from "react";

import Env from "../config";

export const authClient = createAuthClient({
  /** The base URL of the server (optional if you're using the same domain) */
  baseURL: Env.authUrl,
  sessionOptions: {
    refetchInterval: 120,
    refetchOnWindowFocus: true,
    refetchWhenOffline: false,
  },
});

interface AuthContextType {
  user: { id: string; email: string; name?: string | null } | null;
  loading: boolean;
  signOut: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const session = authClient.useSession();

  const signOut = async () => {
    await authClient.signOut();
  };

  const value: AuthContextType = {
    user: session.data?.user ?? null,
    loading: session.isPending,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}
